module.exports = __webpack_public_path__ + "static/media/Kirkway-Estates-Master-Deed-bylaws.f8f87bba.pdf";